import * as React from "react";
import { connect } from "react-redux";
// import Country from "./country";
// import City from "./city";
import * as RegionInstance from "./instance";
import FormModel from "../../viewModel/formModel";
// 国家城市

interface ICountryCityProps {
  countryFormData: FormModel;
  cityFormData: FormModel;
  CreateForm: any;
}

class CountryCity extends React.Component<ICountryCityProps, any> {
  constructor(props: ICountryCityProps) {
    super(props);
  }

  getValue = (model, field) => {
    for (const key in this.props.CreateForm[model]) {
      if (key === field) {
        return this.props.CreateForm[model][key];
      } else {
        continue;
      }
    }
    return null;
  };

  render() {
    // 获取Redux 中的值
    let countryValue = this.getValue(
      this.props.countryFormData.modelName,
      this.props.countryFormData.field
    );
    this.props.countryFormData.value = countryValue;

    // 获取保持在Redux中的值
    let cityValue = this.getValue(
      this.props.cityFormData.modelName,
      this.props.cityFormData.field
    );
    this.props.cityFormData.value = cityValue;

    return (
      <React.Fragment>
        {RegionInstance.getCountry(this.props.countryFormData)}
        <span style={{ marginLeft: 8 }}>
          {RegionInstance.getCity(this.props.cityFormData)}
        </span>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  CreateForm: state.antDemo
});

const mapDispatch = dispatch => {
  return {
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(CountryCity);
